"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderPopover = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _responsive = require("../responsive");

var _context = require("../context");

var _PopoverContainer = _interopRequireDefault(require("./PopoverContainer"));

var _Popover = _interopRequireDefault(require("./Popover"));

var _PopoverContent = _interopRequireDefault(require("./PopoverContent"));

var _PopoverWrapper = _interopRequireDefault(require("./PopoverWrapper"));

var _constants = require("./constants");

var _core = require("@emotion/core");

var _POPOVER_POSITION$BOT, _POPOVER_POSITION$TOP, _ARROW_POSITION_MAP;

var ARROW_POSITION_MAP = (_ARROW_POSITION_MAP = {}, (0, _defineProperty2.default)(_ARROW_POSITION_MAP, _constants.POPOVER_POSITION.BOTTOM, (_POPOVER_POSITION$BOT = {}, (0, _defineProperty2.default)(_POPOVER_POSITION$BOT, _constants.POPOVER_ALIGNMENT.LEFT, _constants.ARROW_POSITION.TOP_LEFT), (0, _defineProperty2.default)(_POPOVER_POSITION$BOT, _constants.POPOVER_ALIGNMENT.RIGHT, _constants.ARROW_POSITION.TOP_RIGHT), (0, _defineProperty2.default)(_POPOVER_POSITION$BOT, _constants.POPOVER_ALIGNMENT.CENTER, _constants.ARROW_POSITION.TOP_CENTER), _POPOVER_POSITION$BOT)), (0, _defineProperty2.default)(_ARROW_POSITION_MAP, _constants.POPOVER_POSITION.TOP, (_POPOVER_POSITION$TOP = {}, (0, _defineProperty2.default)(_POPOVER_POSITION$TOP, _constants.POPOVER_ALIGNMENT.LEFT, _constants.ARROW_POSITION.BOTTOM_LEFT), (0, _defineProperty2.default)(_POPOVER_POSITION$TOP, _constants.POPOVER_ALIGNMENT.RIGHT, _constants.ARROW_POSITION.BOTTOM_RIGHT), (0, _defineProperty2.default)(_POPOVER_POSITION$TOP, _constants.POPOVER_ALIGNMENT.CENTER, _constants.ARROW_POSITION.BOTTOM_CENTER), _POPOVER_POSITION$TOP)), _ARROW_POSITION_MAP);

var getArrowPosition = function getArrowPosition(popoverPosition, popoverAlignment) {
  return ARROW_POSITION_MAP[popoverPosition][popoverAlignment];
};

var handleKeyPress = function handleKeyPress(e, close) {
  if (e.key === 'Escape') {
    close();
  }
};

var renderPopover = function renderPopover(_ref) {
  var isOpen = _ref.isOpen,
      _ref$popoverPosition = _ref.popoverPosition,
      popoverPosition = _ref$popoverPosition === void 0 ? _constants.POPOVER_POSITION.BOTTOM : _ref$popoverPosition,
      _ref$popoverAlignment = _ref.popoverAlignment,
      popoverAlignment = _ref$popoverAlignment === void 0 ? _constants.POPOVER_ALIGNMENT.LEFT : _ref$popoverAlignment,
      popoverWidth = _ref.popoverWidth,
      popoverMaxWidth = _ref.popoverMaxWidth,
      transitionTime = _ref.transitionTime,
      renderPopoverContent = _ref.renderPopoverContent,
      close = _ref.close,
      padding = _ref.padding,
      buttonPopover = _ref.buttonPopover,
      setPopoverRef = _ref.setPopoverRef,
      ariaHasPopup = _ref['aria-haspopup'];
  var paddingProp = padding ? {
    padding: padding
  } : {};
  var maxWidthProp = popoverMaxWidth ? {
    maxWidth: popoverMaxWidth
  } : {};
  return (0, _core.jsx)(_context.StencilConsumer, null, function (_ref2) {
    var selectors = _ref2.selectors;
    return (0, _core.jsx)(_responsive.WithBreakpoints, null, function (viewport) {
      return (0, _core.jsx)(_PopoverWrapper.default, {
        selectors: selectors,
        popoverPosition: popoverPosition,
        popoverAlignment: popoverAlignment,
        buttonPopover: buttonPopover,
        ref: setPopoverRef
      }, (0, _core.jsx)(_PopoverContainer.default, (0, _extends2.default)({
        "data-test-component": "PopoverContainer",
        width: popoverWidth
      }, maxWidthProp, paddingProp), (0, _core.jsx)(_Popover.default, {
        "data-test-component": "Popover",
        selectors: selectors,
        arrowPosition: getArrowPosition(popoverPosition, popoverAlignment),
        onKeyDown: function onKeyDown(e) {
          return handleKeyPress(e, close);
        },
        isOpen: isOpen,
        transitionTime: transitionTime
      }, (0, _core.jsx)(_PopoverContent.default, {
        role: ariaHasPopup,
        "data-test-component": "PopoverContent",
        selectors: selectors,
        tabIndex: 0,
        id: "popoverContent",
        isOpen: isOpen,
        transitionTime: transitionTime,
        shouldSlideUp: popoverPosition === _constants.POPOVER_POSITION.TOP,
        isSmallScreen: viewport.matches.s
      }, renderPopoverContent({
        close: close
      })))));
    });
  });
};

exports.renderPopover = renderPopover;